import { GET_COLD_FLU_STORIES } from '../actions/coldFluActions';

const initialState = {
    coldFluStories: [],
    coldFluStoriesIsFetching: false
};

export function coldFluStories(state = initialState, action)
{

    switch (action.type)
    {
        case GET_COLD_FLU_STORIES.pending:
        {
            return {
                ...state,
                coldFluStoriesIsFetching: true,
                coldFluStories: initialState.coldFluStories
            };
        }
        case GET_COLD_FLU_STORIES.fulfilled:
        {
            return {
                ...state,
                lastError: {},
                coldFluStoriesIsFetching: false,
                coldFluStories: action.payload
            };
        }

        case GET_COLD_FLU_STORIES.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                coldFluStoriesIsFetching: false,
                coldFluStories: initialState.coldFluStories
            };
        }
        default:
            return state;
    }

}
